import { Pill } from '@domgen/base-design-system-2.0/atoms/Pill';
import { Clock } from '../../../assets/icons/Clock';

export type OfferPanelProps = {
  discountPercentage?: number;
  discountTerm?: number;
  show2MonthsPromotion?: boolean;
  netFirstPaymentAmount: number;
  netFirstPaymentAmountAfterPromotionalPeriod?: number;
  periodOfCover: number;
  discountPaymentType?: 'cc' | 'ach';
};

const styles = {
  offerPanel:
    'flex flex-col items-center text-center gap-space-200 py-space-400 px-space-500 rounded-radius-200 bg-primary-100 w-full ',
};

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const OfferPanel = ({
  periodOfCover,
  discountPercentage,
  discountTerm,
  show2MonthsPromotion,
  netFirstPaymentAmount,
  netFirstPaymentAmountAfterPromotionalPeriod,
  discountPaymentType,
}: OfferPanelProps) => {
  const payment = (
    <h6 className="text-h6 text-headline">
      {!!netFirstPaymentAmountAfterPromotionalPeriod &&
        !show2MonthsPromotion &&
        netFirstPaymentAmount < netFirstPaymentAmountAfterPromotionalPeriod && (
          <span className="line-through text-button-text-outline-disabled mr-2">
            {currencyFormatter.format(netFirstPaymentAmountAfterPromotionalPeriod)}
          </span>
        )}
      {currencyFormatter.format(netFirstPaymentAmount)} a month
    </h6>
  );

  const formatPillText = () => {
    const achMarker = discountPaymentType === 'ach' ? '*' : '';

    if (show2MonthsPromotion) {
      return "Our Lowest Price Ever is Back - Don't Miss Out!";
    }

    if (discountPercentage && discountTerm === periodOfCover) {
      return `Offer - ${discountPercentage}% off${achMarker}`;
    }

    if (discountPercentage && discountTerm && discountTerm < periodOfCover) {
      return `Offer - ${discountPercentage}% off for first ${discountTerm} months${achMarker}`;
    }

    return (
      <>
        <Clock />
        ONLINE OFFER
      </>
    );
  };

  return (
    <div className={styles.offerPanel}>
      <Pill variant="success">
        <h6 className="flex justify-center items-center gap-space-100 text-body-small-strong">
          {formatPillText()}
        </h6>
      </Pill>

      {payment}
      <div className="flex flex-col gap-space-200">
        <p className="text-body-strong text-success-600">Monthly subscription, cancel anytime.</p>
        <p className="text-body-small">
          Applicable taxes calculated during checkout.
          {discountPaymentType === 'ach' &&
            !show2MonthsPromotion &&
            ' *Discount applies to payments made via Bank Account only.'}
        </p>
      </div>
    </div>
  );
};
